import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { BILLING_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { AllCostPage } from '@/features/billing/pages/AllCostPage';
import { allCostSearchSchema } from '@/features/billing/types/billing.types';

export const Route = createFileRoute('/_auth/billing/all-cost')({
  beforeLoad: () => requirePermission(BILLING_PERMISSIONS.ALL_COST_VIEW),
  validateSearch: allCostSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="View All Cost">
      <Suspense fallback={<PageLoader />}>
        <AllCostPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
